import React from "react";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import "./index.scss";
import { clearAuthData } from "../../helpers";
import { useAuth } from "../../contexts/AuthProvider";

export default function WarningModal({ isLoading, type, message, showWarningModal, setShowWarningModal }) {
    const history = useHistory();
    const { setAuthed } = useAuth();

    const handleClose = () => {
        setShowWarningModal(false);
        if (type === "ChangePassword") {
            clearAuthData();
            setAuthed({ isAuth: false, token: "", user: {} });
            history.push("/signin");
        }
    };

    return (
        <Modal
            show={showWarningModal}
            onHide={handleClose}
            keyboard={false}
            size="md"
            centered
            className="warning-modal-style"
            backdrop={true}
        >
            <Modal.Body className="text-center p-4">
                {type === "ChangePassword" || type === "EnquiryForm" || type === "KnowMorePrivate" ? (
                    <>
                        <i className="bi bi-check-circle display-5 text-success"></i>
                        <p className="text-success mt-2">{message}</p>
                        <div className="mt-3">
                            <button className="btn btn-primary-color" onClick={handleClose}>
                                {(type === "EnquiryForm" || type === "KnowMorePrivate") ? "Ok" : "Back to Login"}
                            </button>
                        </div>
                    </>
                ) : type === "Plan" ? (
                    <>
                        <p>{message}</p>
                        <div className="mt-3">
                            <button className="btn btn-secondary-color btn-border-color me-3" onClick={handleClose}>
                                Cancel
                            </button>
                            <button className="btn btn-primary-color" onClick={()=> history.push("/subscriptions")}>
                                Upgrade Plan
                            </button>
                        </div>
                    </>
                ) : null}
            </Modal.Body>
        </Modal>
    );
}
